// Function to set up the click listener for the size guide link
  function setupSizeGuideLink() {
    // Select the link using its specific class and href target
    const sizeGuideLink = document.querySelector('.product__size-guide-link a[href="#size-guide-anchor"]');
    
    if (sizeGuideLink) {
      // Remove previous listener to prevent duplication if section is reloaded
      sizeGuideLink.removeEventListener('click', handleSizeGuideClick); 
      // Add the new listener
      sizeGuideLink.addEventListener('click', handleSizeGuideClick); 
    }
  }

  // Function to handle the click event (scroll and open the tab)
  function handleSizeGuideClick(e) {
    e.preventDefault(); // Stop the default browser jump

    const targetElement = document.getElementById('size-guide-anchor');

    if (!targetElement) return;

    // 1. Scroll smoothly to the target DIV container
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start' // Aligns the top of the element to the top of the viewport
    });

    // 2. Open the <details> element inside that container
    const detailsElement = targetElement.querySelector('details');
    if (detailsElement && !detailsElement.open) {
      // Use a slight timeout to ensure the scroll action initiates first
      setTimeout(() => {
        detailsElement.open = true;
      }, 50); 
    }
  }

  // Execute the setup function:
  // 1. When the page is fully loaded (standard)
  document.addEventListener('DOMContentLoaded', setupSizeGuideLink);

  // 2. When the section is reloaded or selected in the Theme Editor (Theme Editor compatibility)
  document.addEventListener('shopify:section:load', setupSizeGuideLink);
  document.addEventListener('shopify:section:select', setupSizeGuideLink);